import { ODSColumn, ODSGrid } from '@telekom-ods/react-ui-kit';
import { Suspense, lazy, useCallback } from 'react';
import { useNavigate } from 'react-router';

import keycloak from '../../keycloak';
import SideNavigationMain from '../SidebarNavigation/SideNavigationMain';

import PageContent from './PageContent';
import RemoteBoundary from './RemoteBoundary';

const NotificationMFProvider = lazy(
  () => import('notificationMicrofrontend/NotificationMFProvider')
);
const NOTIFICATION_API_BASE = import.meta.env.VITE_NOTIFICATION_V1_BASE ?? '/notifications/api/v1';

const Layout = () => {
  const { authenticated, idToken } = keycloak;
  const navigate = useNavigate();

  const getNotificationAccessToken = useCallback(async (): Promise<string | undefined> => {
    await keycloak.updateToken(30);

    return keycloak.token;
  }, []);

  const handleNavigate = useCallback(
    (target: string): void => {
      void navigate(target);
    },
    [navigate]
  );

  return (
    <ODSGrid columns={14}>
      {authenticated ? (
        <RemoteBoundary name='NotificationMFProvider'>
          <Suspense fallback={null}>
            <NotificationMFProvider
              apiBaseUrl={NOTIFICATION_API_BASE}
              enableSse
              getAccessToken={getNotificationAccessToken}
              onNavigate={handleNavigate}
            />
          </Suspense>
        </RemoteBoundary>
      ) : null}
      <div
        className='container'
        style={{
          display: 'flex',
          flexDirection: 'row',
          height: '100vh',
          overflow: 'auto',
        }}
      >
        <ODSColumn
          style={{
            position: 'sticky',
            top: 0,
            alignSelf: 'flex-start',
            height: '100vh',
            flexShrink: 0,
            zIndex: 10,
          }}
        >
          <SideNavigationMain {...{ authenticated, idToken, keycloak }} />
        </ODSColumn>
        <PageContent />
      </div>
    </ODSGrid>
  );
};

export default Layout;
